// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"199":"views","282":"views-app","768":"App","914":"views-error"}[chunkId] || chunkId) + "." + {"19":"48914798","199":"ddd9e45d","282":"e22039f6","521":"7dee35df","538":"7e6c59fe","746":"81de4a2b","768":"167b9fad","852":"e7e13f8f","914":"16349be9"}[chunkId] + ".chunk.js";
};